module.exports = __webpack_public_path__ + "img/ic_logo_moonlight@2x.f55bb9db.png";